// extracted by mini-css-extract-plugin
export default {"baseButton":"BrandButton_baseButton__xGqvs"};